import { Route, RouteComponentProps, RouteProps } from 'react-router';
import AuthorizationGuard from '@/shared/components/AuthorizationGuard/AuthorizationGuard';

type Props = RouteProps;

const ProtectedRoute: React.FC<Props> = ({ component: Component, ...delegated }) => {
  return (
    <Route
      {...delegated}
      render={(props: RouteComponentProps) => {
        return (
          Component && (
            <AuthorizationGuard>
              <Component {...props} {...delegated} />
            </AuthorizationGuard>
          )
        );
      }}
    />
  );
};

export default ProtectedRoute;
